import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class GrantCreditsArgs extends ActionArgs {
  /** Target owner for this grant — a `User._id` (User scope) or `Tenant._id` (Tenant scope). */
  @Field(() => ID)
  ownerId: string

  @Field(() => Float)
  credits: number

  /** Overrides the app's `defaultCurrency` when creating a new account. Rejected if it differs from an existing account's currency. */
  @Field(() => String, { nullable: true })
  currency?: string

  @Field(() => String, { nullable: true })
  reason?: string
}
